<span>
  {{ collectiveAgreementValidTo | date:'dd.MM.yyyy' }}
</span>
